<script lang="ts" setup>
import startsWith from 'lodash-es/startsWith';

const model = defineModel<any>();
const slugInput = ref();
const props = withDefaults(defineProps<{
    source: any;
    name: string;
    type?: string;
    size?: 'sm' | 'md' | 'lg';
    fluid?: boolean;
}>(), {
    type: 'text',
    size: 'md',
    fluid: true
});

const size = computed<any>(() => props.size == 'md'
    ? null
    : props.size == 'sm'
        ? 'small'
        : 'large'
);

watch (() => props.source, () =>
{
    copySymbol(false);
});

function copySymbol(force: boolean): void
{
    const slugifyFn = (slugInput.value?.$el as any)?.slugify as ((value: string) => string) | undefined;

    if (!slugifyFn) return;

    const slug = slugifyFn(String(props.source ?? ''));
    const currentValue = String(model.value ?? '');

    if ((Math.abs(slug.length - currentValue.length) === 1 && (startsWith(slug, currentValue) || startsWith(currentValue, slug))) || force === true)
    {
        model.value = slug;
    }
}
</script>

<template>
    <PrimeInputGroup>
        <PrimeInputText
            ref="slugInput"
            v-model="model"
            v-slugify
            :name="props.name"
            :type="props.type"
            :size="size"
            :fluid="props.fluid"
        />
        <PrimeInputGroupAddon>
            <PrimeButton
                icon="fas fa-fw fa-sync"
                severity="secondary"
                @click.prevent="copySymbol(true)"
            />
        </PrimeInputGroupAddon>
    </PrimeInputGroup>
</template>
